import { ROUTES } from '@/constants/routes'

export default function isNotCompleteQuestionnaire({ next, router, store }) {
    const { account, getWorkspaceSlug } = store

    if ((account && account.verification_questionnaire) || account.is_active) {
        return router.push({ name: ROUTES.reporting, params: { workspace: getWorkspaceSlug } })
    }

    next()
}
